import './styles/main.css';
import './config/i18n';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AdminLayout } from './components/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import queryClient from './config/queryClient';
import ModuleFilterProvider from './context/ModuleFilter';
import PermissionsProvider from './context/Permissions';
import { ConversationDetail } from './pages/ConversationDetail';
import { Conversations } from './pages/Conversations';
import { Dashboard } from './pages/Dashboard';
import { Dependencies } from './pages/Dependencies';
import { Evaluations } from './pages/Evaluations';
import { JudgeDetail } from './pages/JudgeDetail';
import { Judges } from './pages/Judges';
import { ModuleDetail } from './pages/ModuleDetail';
import { Modules } from './pages/Modules';
import { Reports } from './pages/Reports';

if (import.meta.env.BUSINESS_INTERCEPT_REQUEST === 'true') {
	import('../mocks/browser').then(({ mockWorker }) => {
		mockWorker.start();
	});
}

const App = () => (
	<StrictMode>
		<div className="mf-ai-agents">
			<QueryClientProvider client={queryClient}>
				<PermissionsProvider>
					<ModuleFilterProvider>
						<BrowserRouter>
							<Routes>
								<Route element={<AdminLayout />}>
									<Route
										index
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Dashboard />
											</ProtectedRoute>
										}
									/>
									<Route
										path="modules"
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Modules />
											</ProtectedRoute>
										}
									/>
									<Route
										path="modules/:moduleName"
										element={
											<ProtectedRoute permission={(p) => !!p.show}>
												<ModuleDetail />
											</ProtectedRoute>
										}
									/>
									<Route
										path="conversations"
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Conversations />
											</ProtectedRoute>
										}
									/>
									<Route
										path="conversations/:threadId"
										element={
											<ProtectedRoute permission={(p) => !!p.show}>
												<ConversationDetail />
											</ProtectedRoute>
										}
									/>
									<Route
										path="judges"
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Judges />
											</ProtectedRoute>
										}
									/>
									<Route
										path="judges/:id"
										element={
											<ProtectedRoute permission={(p) => !!p.show}>
												<JudgeDetail />
											</ProtectedRoute>
										}
									/>
									<Route
										path="evaluations"
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Evaluations />
											</ProtectedRoute>
										}
									/>
									<Route
										path="reports"
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Reports />
											</ProtectedRoute>
										}
									/>
									<Route
										path="dependencies"
										element={
											<ProtectedRoute permission={(p) => !!p.list}>
												<Dependencies />
											</ProtectedRoute>
										}
									/>
								</Route>
							</Routes>
						</BrowserRouter>
					</ModuleFilterProvider>
				</PermissionsProvider>
				<ReactQueryDevtools />
			</QueryClientProvider>
		</div>
	</StrictMode>
);

export default App;
